var map = {
	"./aboutUs6.png": 667,
	"./aboutUs62024.png": 668,
	"./aboutUs6_en.jpg": 669,
	"./aboutUs6_en.png": 670,
	"./aboutUs6_en2024.png": 671
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 666;